<template>
    <b-modal v-model="modal.show"
             hide-footer
             centered
             :title="(editing ? 'Editar' : 'Crear') + ' Empresas formadoras' "
    >
        <b-form @submit.prevent="validateForm()"
                data-vv-scope="training_companies"
        >

            <b-row>
                <b-col cols="12">
                    <b-form-group>
                        <label for="sys_list_identification_type_id">Tipo de Identificación</label>
                        <el-select v-model="training_company.sys_list_identification_type_id"
                                   id="sys_list_identification_type_id"
                                   name="sys_list_identification_type_id"
                                   filterable
                                   size="small"
                                   placeholder="Seleccione tipo de identificación"
                                   class="w-100"
                                   no-data-text="No hay datos que coincidan"
                                   no-match-text="No hay datos que coincidan"
                                   data-vv-as=" "
                                   v-validate="'required|min:3|max:255'"

                        >
                            <el-option v-for="type in types"
                                       :key="type.id"
                                       :label="type.lista"
                                       :value="type.id"
                            />
                        </el-select>
                        <div class="text-danger small"
                             v-text="errors.first('training_companies.sys_identification_type_id')"
                        />
                    </b-form-group>
                </b-col>

                <b-col cols="12">
                    <b-form-group>
                        <label for="identification">Identificación</label>
                        <el-input id="identification"
                                  name="identification"
                                  size="small"
                                  v-model="training_company.identification"
                                  data-vv-as=" "
                                  v-validate="'required|min:3|max:10'"
                        />
                        <div class="text-danger small"
                             v-text="errors.first('training_companies.identification')"
                        />
                    </b-form-group>
                </b-col>
                
                <b-col cols="12">
                    <b-form-group>
                        <label for="name">Nombre</label>
                        <el-input id="name"
                                  name="name"
                                  size="small"
                                  v-model="training_company.name"
                                  data-vv-as=" "
                                  v-validate="'required|min:3|max:255'"
                        />
                        <div class="text-danger small"
                             v-text="errors.first('training_companies.name')"
                        />
                    </b-form-group>
                </b-col>
            </b-row>

            <b-row>
                <div class="w-100 text-center">
                    <hr/>

                    <b-btn variant="primary"
                           class="mx-1"
                           size="sm"
                           @click="validateForm()"
                    >
                        <i class="fa fa-save"/> Guardar
                    </b-btn>
                    <b-btn variant="secondary"
                           class="mx-1"
                           size="sm"
                           @click="setModalShow(false)"
                    >
                        <i class="fa fa-close"/> Cancelar
                    </b-btn>
                </div>
            </b-row>
        </b-form>


    </b-modal>
</template>

<script>
import {mapActions, mapMutations, mapState} from 'vuex';

export default {
    name: 'modal',
    computed: {
        ...mapState('training_companies', [
            'training_company',
            'editing',
            'modal',
            'types'
        ])
    },
    methods: {
        ...mapActions('training_companies', [
            'addTrainingCompany',
            'updateTrainingCompany'
        ]),
        ...mapMutations('training_companies', [
            'resetParams',
            'setModalShow'
        ]),
        ...mapMutations('dashboard', ['load']),
        validateForm() {
            this.$validator.validateAll('training_companies')
                .then((result) => {
                    if (result) {
                        if (this.editing) {
                            this.updateTrainingCompany();
                        } else {
                            this.addTrainingCompany();
                        }
                    }
                });
        }
    },
};
</script>

<style scoped>
</style>
